import { render, staticRenderFns } from "./planDetails_gl.vue?vue&type=template&id=9b1877f0&scoped=true"
import script from "./planDetails_gl.vue?vue&type=script&lang=js"
export * from "./planDetails_gl.vue?vue&type=script&lang=js"
import style0 from "./planDetails_gl.vue?vue&type=style&index=0&id=9b1877f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1877f0",
  null
  
)

export default component.exports